module.exports = __webpack_public_path__ + "static/img/banner_bg12.27b0451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner_bg12.jpg
// module id = WY58
// module chunks = 9